/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const CROP_STATUSES = [
  'pending',
  'cropping',
  'cropped',
  'uploading',
  'uploaded',
  'failed',
] as const;

export const cropStatusSchema = z.enum(CROP_STATUSES);

export type ICropStatus = z.infer<typeof cropStatusSchema>;
